export default {
  URL: "https://links.toanf.com/"
}